import { createTermTagManager } from '../../utils/createTermTagManager';

export const withLayoutTagManager = createTermTagManager({
  jsonQueryKey: 'with_layout',
  label: 'Со схемой планировки',
  id: 'withLayout',
});
